import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Buscador = ({ lang, destinos, tiposcasas }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";


    const [activeTab, setActiveTab] = useState(1);
    const [form1, setForm1] = useState({
        destino: '',
        tipo_barco: '',
        cabinas: '',
        precio_min: '',
        formulario: 1
    });
    const [form2, setForm2] = useState({
        destino: '',
        tipo_barco: '19',
        personas: '',
        precio_min: '',
        formulario: 2
    });

    const activateTab = (tabId) => {
        setActiveTab(tabId);
    };

    const handleTabKeyDown = (e, idx) => {
        const tabs = [1, 2]; // IDs de tabs
        const current = idx;
        if (['ArrowRight', 'ArrowLeft', 'Home', 'End', 'Enter', ' '].includes(e.key)) {
            e.preventDefault();
            let next = current;
            if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
            if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = tabs.length - 1;
            if (e.key === 'Enter' || e.key === ' ') {
                activateTab(tabs[idx]);
                return;
            }
            // En React, enfocamos el botón correspondiente
            document.getElementById(`tab-${tabs[next]}`).focus();
            activateTab(tabs[next]);
        }
    };

    const handleSubmit1 = (e) => {
        e.preventDefault();
        console.log('Buscar panel 1:', form1);
        // Reemplaza con lógica real, e.g., fetch o navegación
        document.getElementById('form1').submit();

    };

    const handleSubmit2 = (e) => {
        e.preventDefault();
        console.log('Buscar panel 2:', form2);
        // Reemplaza con lógica real
        document.getElementById('form2').submit();
    };

    const handleReset1 = () => {
        setForm1({
            destino: '',
            tipo_barco: '',
            cabinas: '',
            precio_min: ''
        });
        // Enfocar primer campo después de reset
        setTimeout(() => document.getElementById('destino-1').focus(), 0);
    };

    const handleReset2 = () => {
        setForm2({
            destino: '',
            personas: '',
            precio_min: ''
        });
        // Enfocar primer campo después de reset
        setTimeout(() => document.getElementById('destino-2').focus(), 0);
    };

    useEffect(() => {
        // Foco inicial en el primer campo del panel activo
        const firstInput = document.getElementById('destino-1');
        if (firstInput) firstInput.focus();
    }, []);

    let destinations = [];

    for (var i = 0; i < destinos.length; i++) {
        destinations.push({ "nombre": destinos[i].elnombre, "id": destinos[i].id })
    }

    let boatTypes = [];

    for (var i = 0; i < tiposcasas.length; i++) {
        if (tiposcasas[i].id != 19)
            boatTypes.push({ "nombre": tiposcasas[i].nombre, "id": tiposcasas[i].id });
    }

    const cabins = ['1+', '2+', '3+', '4+', '5+', '6+', '7+', '8+'];

    return (
        <>
            <style>
                {`
                    root{
                        --bg: #ffffff;
                        --panel: #ffffff;
                        --muted: #6b7280; /* gray-500 */
                        --text: #111827; /* gray-900 */
                        --brand: #20679c; /* cyan-700 */
                        --brand-2: #20679c; /* blue-500 */
                        --ring: 0 0 0 3px rgba(59,130,246,.35);
                        --radius: 16px;
                        --shadow: 0 10px 30px rgba(0,0,0,.10);
                    }
                    * { box-sizing: border-box; }
                    html, body { margin: 0; height: 100%; background: var(--bg); color: var(--text); font-
family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, &#39;Helvetica Neue&#39;, Arial, &#39;Noto
Sans&#39;, &#39;Apple Color Emoji&#39;, &#39;Segoe UI Emoji&#39;, &#39;Segoe UI Symbol&#39;; }
                    .wrap { display: grid; place-items: center; min-height: 100%; padding: 24px; }
                    .search-card{ width: min(100%, 1100px); background: var(--panel); border: 1px solid
                    rgba(17,24,39,.12); border-radius: var(--radius); box-shadow: var(--shadow); }
                    .tabs{ display: grid; grid-template-columns: 1fr 1fr; gap: 4px; padding: 4px; background:
                    #f3f4f6; border-radius: calc(var(--radius) - 6px) calc(var(--radius) - 6px) 0 0;}
                    .tab-btn{ position: relative; appearance: none; background: transparent; border: 0;
                    color: var(--muted); font-weight: 600; letter-spacing: .2px; padding: 10px 14px; border-
                    radius: 10px; cursor: pointer; transition: .2s ease; }
                    .tab-btn[aria-selected=&quot;true&quot;]{ color: #0f172a; background: linear-gradient(180deg,
                    rgba(34,211,238,.15), rgba(96,165,250,.15)); box-shadow: inset 0 0 0 1px
                    rgba(17,24,39,.06); }
                    .tab-btn:focus-visible{ outline: none; box-shadow: var(--ring); }
                    .tab-btn.active {border: 1px solid rgb(32, 103, 156); background: rgb(32, 103, 156); color: #fff; text-decoration:underline;border-radius: 10px;}
                    .panel{ display: none; padding: 12px; }
                    .panel.active{ display: block; }
                    .form-row{ display: grid; gap: 8px; grid-template-columns: 1.1fr 1fr 1fr auto; align-items:
                    end; }

                    .form-row.four-cols{ display: grid; gap: 8px; grid-template-columns: 1.1fr 1fr 1fr 1fr
                    auto; align-items: end; }
                    .field{ display: grid; gap: 6px; }
                    .field label{ font-size: 12px; color: var(--muted); letter-spacing: .25px; }
                    .control{ display: flex; align-items: center; gap: 6px; background: var(--panel); padding:
                    8px 12px; border-radius: 10px; border: 1px solid rgba(17,24,39,.12); }
                    .control:focus-within{ box-shadow: var(--ring); border-color: rgba(34,211,238,.6); }
                    select, input{ flex: 1; background: transparent; border: 0; color: var(--text); font-size:
                    14px; outline: none; min-width: 0; }
                    input[type=&quot;number&quot;]::-webkit-outer-spin-button,
                    input[type=&quot;number&quot;]::-webkit-inner-spin-button{ -webkit-appearance: none; margin:
                    0; }
                    input[type=&quot;number&quot;]{ -moz-appearance: textfield; }

                    .actions{ display: flex; gap: 10px; align-items: center; }
                    .btn{ appearance: none; border: 0; padding: 10px 14px; border-radius: 10px; font-
                    weight: 700; cursor: pointer; transition: .2s ease; }
                    .btn-primary{ background: #20679c; color: #fff; }
                    .btn-primary:hover{ background: #1b5a86; transform: translateY(-1px); }
                    .btn-ghost{ background: #f3f4f6; color: #111827; }

                    .form-container{ background: #FFF;}

                    .fineprint{ margin-top: 6px; font-size: 8pt; color: var(--muted); }

                    /* Media queries para responsive */
                    @media (max-width: 960px){
                        .form-row{ grid-template-columns: 1fr 1fr; }
                        .actions{ grid-column: 1 / -1; justify-content: flex-start; }
                    }
                    @media (max-width: 560px){
                        .form-row{ grid-template-columns: 1fr; }
                    }

                    /* Mejoras para móvil: apilar todo verticalmente y ajustar botones */
                    @media (max-width: 575px) {
                        .wrap { padding: 16px; } /* Reducir padding en móvil */
                        .search-card { width: 100%; margin: 0; z-index: 19; } /* Quitar márgenes extra */
                        .form-row, .form-row.four-cols { grid-template-columns: 1fr; } /* Apilar todos los campos */
                        .actions {
                            grid-column: 1 / -1;
                            justify-content: center;
                            flex-direction: row; /* Mantener botones en fila, pero full width si es necesario */
                            gap: 8px;
                        }
                        .btn {
                            flex: 1; /* Hacer botones ocupar espacio igual */
                            min-width: 0; /* Evitar overflow */
                        }
                        .fineprint { font-size: 10pt; text-align: center; } /* Ajustar texto pequeño */

                        .u-section-1 .u-image-1 {
                            margin: 20px 0;
                        }
                `}
            </style>
            <main>
                <div className="wrap u-image u-image-default u-image-1">
                    <section className="search-card" role="search" aria-label="Buscador de barcos y cruceros">
                        <div className="tabs" role="tablist" aria-label={t("Tipo de viaje")}>
                            <button
                                className={`tab-btn ${activeTab === 1 ? 'active' : ''}`}
                                role="tab"
                                aria-selected={activeTab === 1}
                                aria-controls="panel-1"
                                id="tab-1"
                                onClick={() => activateTab(1)}
                                onKeyDown={(e) => handleTabKeyDown(e, 0)}
                            >
                                {t("Goletas, Yates, Catamaranes")}
                            </button>
                            <button
                                className={`tab-btn ${activeTab === 2 ? 'active' : ''}`}
                                role="tab"
                                aria-selected={activeTab === 2}
                                aria-controls="panel-2"
                                id="tab-2"
                                onClick={() => activateTab(2)}
                                onKeyDown={(e) => handleTabKeyDown(e, 1)}
                            >
                                {t("Cruceros Boutique")}
                            </button>
                        </div>

                        <form className="form-container" id="form1" onSubmit={handleSubmit1} method="get" action={"/" + preidioma + t("buscar-embarcaciones")}>
                            <div
                                id="panel-1"
                                className={`panel ${activeTab === 1 ? 'active' : ''}`}
                                role="tabpanel"
                                aria-labelledby="tab-1"
                                aria-hidden={activeTab !== 1}
                            >
                                <input type="hidden" id="formulario" name="formulario" value={form1.formulario} />
                                <div className="form-row four-cols">
                                    <div className="field">
                                        <label htmlFor="destino-1">{t("Destino")}</label>
                                        <div className="control">
                                            <select
                                                id="destino-1"
                                                name="destino"
                                                value={form1.destino}
                                                onChange={(e) => setForm1({ ...form1, destino: e.target.value })}
                                            >
                                                <option value="" disabled>{t("Selecciona un destino")}</option>
                                                {destinations.map(dest => <option key={dest.nombre} value={dest.id}>{dest.nombre}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="tipo-barco">{t("Tipo de barco")}</label>
                                        <div className="control">
                                            <select
                                                id="tipo-barco"
                                                name="tipo_barco"
                                                value={form1.tipo_barco}
                                                onChange={(e) => setForm1({ ...form1, tipo_barco: e.target.value })}
                                            >
                                                <option value="" disabled>{t("Cualquiera")}</option>
                                                {boatTypes.map(type => <option key={type.nombre} value={type.id}>{type.nombre}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="cabinas">{t("Número de cabinas")}</label>
                                        <div className="control">
                                            <select
                                                id="cabinas"
                                                name="cabinas"
                                                value={form1.cabinas}
                                                onChange={(e) => setForm1({ ...form1, cabinas: e.target.value })}
                                            >
                                                <option value="" disabled>{t("Cualquiera")}</option>
                                                {cabins.map(cab => <option key={cab} value={cab.split('+')[0]}>{cab}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="precio-min-1">{t("Precios desde…")}</label>
                                        <div className="control">
                                            <span className="currency">€</span>
                                            <input
                                                id="precio-min-1"
                                                name="precio_min"
                                                type="number"
                                                placeholder="0"
                                                min="0"
                                                step="50"
                                                value={form1.precio_min}
                                                onChange={(e) => setForm1({ ...form1, precio_min: e.target.value })}
                                                aria-label={t("Precio mínimo en euros")}
                                            />
                                        </div>
                                    </div>
                                    <div className="actions">
                                        <button className="btn btn-primary" type="submit" aria-label={t("Buscar barcos")}>{t("Buscar")}</button>
                                        <button className="btn btn-ghost" type="button" onClick={handleReset1}>{t("Limpiar")}</button>
                                    </div>
                                </div>
                                <p className="fineprint">{t("Consejo: puedes dejar campos en blanco para ver más opciones.")}</p>
                            </div>
                        </form>

                        <form className="form-container" id="form2" onSubmit={handleSubmit2} method="get" action={"/" + preidioma + t("buscar-embarcaciones")}>
                            <div
                                id="panel-2"
                                className={`panel ${activeTab === 2 ? 'active' : ''}`}
                                role="tabpanel"
                                aria-labelledby="tab-2"
                                aria-hidden={activeTab !== 2}
                            >
                                <input type="hidden" id="formulario" name="formulario" value={form2.formulario} />
                                <input type="hidden" id="tipo-barco-2" name="tipo_barco" value={form2.tipo_barco} />

                                <div className="form-row">
                                    <div className="field">
                                        <label htmlFor="destino-2">{t("Destino")}</label>
                                        <div className="control">
                                            <select
                                                id="destino-2"
                                                name="destino"
                                                value={form2.destino}
                                                onChange={(e) => setForm2({ ...form2, destino: e.target.value })}
                                            >
                                                <option value="" disabled>{t("Selecciona un destino")}</option>
                                                {destinations.map(dest => <option key={dest.nombre} value={dest.id}>{dest.nombre}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="personas">{t("Número de personas")}</label>
                                        <div className="control">
                                            <input
                                                id="personas"
                                                name="personas"
                                                type="number"
                                                placeholder="2"
                                                min="1"
                                                step="1"
                                                value={form2.personas}
                                                onChange={(e) => setForm2({ ...form2, personas: e.target.value })}
                                                aria-label={t("Número de personas")}
                                            />
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="precio-min-2">{t("Precios desde…")}</label>
                                        <div className="control">
                                            <span className="currency">€</span>
                                            <input
                                                id="precio-min-2"
                                                name="precio_min"
                                                type="number"
                                                placeholder="0"
                                                min="0"
                                                step="50"
                                                value={form2.precio_min}
                                                onChange={(e) => setForm2({ ...form2, precio_min: e.target.value })}
                                                aria-label={t("Precio mínimo en euros")}
                                            />
                                        </div>
                                    </div>
                                    <div className="actions">
                                        <button className="btn btn-primary" type="submit" aria-label={t("Buscar cruceros boutique")}>{t("Buscar")}</button>
                                        <button className="btn btn-ghost" type="button" onClick={handleReset2}>{t("Limpiar")}</button>
                                    </div>
                                </div>
                                <p className="fineprint">{t("Consejo: indica el número de personas para ver disponibilidad real.")}</p>
                            </div>
                        </form>
                    </section>
                </div>
            </main>
        </>
    );
};

export default Buscador;
